import { ILocationService } from 'angular';

export class DashboardSelectorController {

    static readonly $inject = [
        '$location',
    ];

    dashboardSegments: any[];

    constructor(
        $location: ILocationService
    ) {
        this.dashboardSegments = [
            {
                label: 'fe.menu.cattle.switchView.dashboard',
                onSelect() {
                    $location.path('/dairynet.presentation/dashboard');
                },
                selected: $location.path() ===  '/dairynet.presentation/dashboard'
            },
            {
                label: 'fe.menu.cattle.switchView.management',
                onSelect() {
                    $location.path('/cattle');
                },
                selected: $location.path() ===  '/cattle'
            }
        ];
    }
}
